module.exports = __webpack_public_path__ + "img/domain-03-mobile.baaf8d8f.png";